import { translateAdmin } from '../../../utils/adminTranslations';
import AdminText from '../AdminText';
import React, { useEffect, useState } from 'react';
import { apiUrl } from '../../../config'
import { fetchData } from '../../../utils/api';
import { useLanguage } from '../../../LanguageContext';


const BookingNew = ({ onClose, newHandBookingUser }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const { language } = useLanguage();
    const [guests, setGuests] = useState([{ full_name: '', passport_serial_number: '', currency: 0, is_payer: false, isnot_guest: false }]);
    const [hasCurrency, setHasCurrency] = useState(false)

    const [messageNewData, setMessageNewData] = useState('')
    const [rooms, setRooms] = useState([])
    const [selectedPrice, setSelectedPrice] = useState('')
    const [newBooking, setNewBooking] = useState({
        'note_text': '',
        'blank_number': 0,
        'check_number_card': 0,
        'phone_number': '',
        'available_from': '',
        'check_number_cash': 0,
        'phone_number': '',
        'available_from': '',
        'available_to': '',
        'room_id': '',
        'type': 1,
        'payment_type': 'card',
        'payment_status': 1,
    });
    async function getRooms() {
        try {
            const token = localStorage.getItem('accessToken');
            const rooms = await fetchData(`${apiUrl}/api/sys/get-rooms-by-season`, 'GET', token)
            if (rooms.request.status === 0) {
                setRooms(rooms.request.data)
            }
        } catch (error) {
            console.error("Не удалось получить данные о номерах:", error);
        }
    }

    useEffect(() => {
        getRooms()
    }, [])
    useEffect(() => {
        // Проверяем, есть ли данные rooms и установлен ли room_id
        if (rooms && rooms.length > 0 && newBooking.room_id) {
            const selectedRoom = rooms.find((room) => room.id === parseInt(newBooking.room_id));
            setSelectedPrice(selectedRoom ? selectedRoom.price : '');
        }
    }, [rooms, newBooking.room_id])

    const sendData = async () => {
        const requestData = { ...newBooking, guests, user: newHandBookingUser }
        setIsDisabled(true)
        setMessageNewData('Подождите...')
        try {
            const token = localStorage.getItem('accessToken');
            const response = await fetch(`${apiUrl}/api/sys/new-booking`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(requestData)
            });
            const data = await response.json();
            if (response.ok) {
                setMessageNewData(data.request.message)
            } else {
                setMessageNewData(data.request.message)
                console.error("Ошибка загрузки данных:", response.statusText);
            }
        } catch (error) {
            console.error("Ошибка:", error);
        }
        setTimeout(() => setIsDisabled(false), 3000);
    }
    const check = async () => {
        const requestData = {
            room_id: newBooking.room_id,
            checkin: newBooking.available_from,
            checkout: newBooking.available_to
        }
        setIsDisabled(true)
        setMessageNewData('Подождите...')
        try {
            const token = localStorage.getItem('accessToken');
            const response = await fetch(`${apiUrl}/api/sys/reception-check-fr`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(requestData)
            });
            const data = await response.json();
            if (response.ok) {
                setMessageNewData(`${data.message + ': ' + data.count}`)
            } else {
                setMessageNewData(data.message)
                console.error("Ошибка загрузки данных:", response.statusText);
            }
        } catch (error) {
            console.error("Ошибка:", error);
        }
        setTimeout(() => setIsDisabled(false), 3000);
    }


    // Обработчик изменений для гостя
    const handleGuestChange = (index, field, value) => {
        const updatedGuests = [...guests];
        updatedGuests[index][field] = value;
        setGuests(updatedGuests);
    };

    const setPayer = (payerIndex) => {
        const updatedGuests = guests.map((guest, index) => ({
            ...guest,
            is_payer: index === payerIndex
        }));
        setGuests(updatedGuests);
    };
    const setPayerNotGuest = (payerIndex) => {
        setGuests((prevGuests) => {
            return prevGuests.map((guest, index) => {
                const isCurrentlySelected = guest.isnot_guest === true;

                // Если нажали на уже выбранный — выключаем его
                if (index === payerIndex) {
                    return {
                        ...guest,
                        isnot_guest: !isCurrentlySelected,
                    };
                }

                // Остальные — сбрасываем
                return {
                    ...guest,
                    isnot_guest: false,
                };
            });
        });
    };

    // Добавление гостя
    const addGuest = () => {
        setGuests([...guests, { full_name: '', passport_serial_number: '', currency: 0 }]);
    };

    // Удаление гостя
    const removeGuest = (index) => {
        if (guests.length > 1) {
            setGuests(guests.filter((_, i) => i !== index));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'payment_type') {
            setNewBooking((prev) => ({
                ...prev,
                check_number_card: '',
                check_number_cash: '',
            }))
        }
        if (name === 'type') {
            setNewBooking((prev) => ({
                ...prev,
                payment_status: 1
            }))
            setNewBooking((prev) => ({
                ...prev,
                blank_number: '',
                check_number_card: '',
                check_number_cash: '',
            }))
        }
        setNewBooking((prevBooking) => ({
            ...prevBooking,
            [name]: name === 'type' ? Number(value) : value
        }));

        if (name === 'room_id') {
            // Находим цену для выбранной комнаты и обновляем состояние
            const selectedRoom = rooms.find((room) => room.id === parseInt(value));
            setSelectedPrice(selectedRoom ? selectedRoom.price : ''); // Просто для отрисовки на странице
        }
    };

    useEffect(() => {
        const hasCurrencyGuest = guests.some(g => g.currency === 1);
        setHasCurrency(hasCurrencyGuest)
        if (hasCurrencyGuest) {
            newBooking.payment_status = 2;
        }
    }, [guests, setHasCurrency, newBooking])

    return (
        <div className='system-background-hide'>
            <section className="system-container system-container-form">
                <div className='system-container__inner'>
                    <header className="system-header"><AdminText>Новая бронь</AdminText></header>
                    <form className="system-form">
                        <div className='booking-form__guests'>
                            {guests.map((guest, index) => (
                                <div key={index} className='booking-form__guests__guest'>
                                    <div className="system-input-box">
                                        <div className='radio-payer'>
                                            <label><AdminText>Полное имя #</AdminText>{(1 + index)}</label>
                                            <div className='radio-payer__in'>
                                                <label htmlFor={`is_payer_${index}`}><AdminText>Плательщик:</AdminText></label>
                                                <input type='radio' id={`is_payer_${index}`} checked={!!guest.is_payer} onChange={() => setPayer(index)} />
                                            </div>
                                        </div>
                                        <input
                                            required
                                            placeholder={translateAdmin("Имя Фамилия")}
                                            value={guest.full_name}
                                            type="text"
                                            id={`full_name_${index}`}
                                            name={`full_name_${index}`}
                                            onChange={(e) => handleGuestChange(index, 'full_name', e.target.value)}
                                        />
                                    </div>
                                    <div className="system-input-box">
                                        <label><AdminText>Серийный номер паспорта</AdminText></label>
                                        <input
                                            placeholder={translateAdmin("Серийный номер паспорта")}
                                            value={guest.passport_serial_number}
                                            type="text"
                                            id={`passport_serial_number_${index}`}
                                            name={`passport_serial_number_${index}`}
                                            onChange={(e) => handleGuestChange(index, 'passport_serial_number', e.target.value)}
                                        />
                                    </div>
                                    <div className="system-input-box">
                                        <label><AdminText>Гражданин</AdminText></label>
                                        <select onChange={(e) => handleGuestChange(index, 'currency', parseInt(e.target.value))} value={guest.currency || 0}>
                                            <option value={0}><AdminText>Туркменистана</AdminText></option>
                                            <option value={1}><AdminText>Иностранный</AdminText></option>
                                        </select>
                                    </div>
                                    {guest.is_payer === true &&
                                        <div className="system-input-box radio-payer">
                                            <label htmlFor='payer_notguest'><AdminText>Плательщик не является гостем</AdminText></label>
                                            <input type="checkbox" checked={!!guest.isnot_guest} id='payer_notguest' onChange={() => setPayerNotGuest(index)} />
                                        </div>
                                    }
                                    {guests.length > 1 && (
                                        <button type="button" className='button-booking button-booking-small' onClick={() => removeGuest(index)}>
                                            <AdminText>Удалить гостя</AdminText>
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className='booking-form__buttons'>
                            {/* Кнопка добавления гостя */}
                            <button type="button" className='button-booking button-booking-small' onClick={addGuest}>
                                <AdminText>Добавить гостя</AdminText>
                            </button>

                        </div>
                        <div className="system-column">
                            <div className="system-input-box system-address">
                                <label><AdminText>Тип бронирования</AdminText></label>
                                <div className="system-select-box">
                                    <select required value={newBooking.type} onChange={handleInputChange} name='type'>
                                        <option value={1}><AdminText>Бланк</AdminText></option>
                                        <option value={2}><AdminText>Чеком</AdminText></option>
                                        <option value={3}><AdminText>Заметка</AdminText></option>
                                        <option value={4}><AdminText>Перечисление</AdminText></option>
                                    </select>
                                </div>
                            </div>
                            {newBooking.type === 1 ? (
                                <div className="system-input-box">
                                    <label><AdminText>Номер бланка</AdminText></label>
                                    <input
                                        disabled={true}
                                        placeholder={translateAdmin("Автоматически выборе бланка")}
                                        value={newBooking.blank_number || ''}
                                        type="number"
                                        name="blank_number"
                                        onChange={handleInputChange}
                                    />
                                </div>
                            ) : newBooking.type === 2 ? (
                                <div className="system-input-box">
                                    <label><AdminText>Номер чека</AdminText></label>
                                    {newBooking.payment_type === 'card' ? (
                                        <input
                                            disabled={true}
                                            placeholder={translateAdmin("Автоматически выборе чека")}
                                            value={newBooking.check_number_card || ''}
                                            type="number"
                                            name="check_number_card"
                                            onChange={handleInputChange}
                                        />
                                    ) : newBooking.payment_type === 'cash' ? (
                                        <input
                                            disabled={true}
                                            placeholder={translateAdmin("Автоматически выборе чека")}
                                            value={newBooking.check_number_cash || ''}
                                            type="number"
                                            name="check_number_cash"
                                            onChange={handleInputChange}
                                        />
                                    ) : null}
                                </div>
                            ) : null}
                            {newBooking.type === 2 &&
                                <div className="system-input-box system-address">
                                    <label><AdminText>Тип оплаты:</AdminText></label>
                                    <div className="system-select-box">
                                        <select required value={newBooking.payment_type} onChange={handleInputChange} name='payment_type'>
                                            <option value='card'><AdminText>Карта</AdminText></option>
                                            <option value='cash'><AdminText>Наличные</AdminText></option>
                                        </select>
                                    </div>
                                </div>
                            }
                            <div className="system-input-box system-address">
                                <label><AdminText>Оплата:</AdminText></label>
                                <div className="system-select-box">
                                    <select required value={newBooking.payment_status} onChange={handleInputChange} name='payment_status'>
                                        {!hasCurrency && (
                                            <option value={1}><AdminText>Бронь</AdminText></option>
                                        )}
                                        <option value={2}><AdminText>номер</AdminText></option>
                                        {!hasCurrency && (
                                            <option value={3}><AdminText>Бронь и номер</AdminText></option>
                                        )}
                                        {newBooking.type === 3 &&
                                            <option value={4}><AdminText>без оплаты</AdminText></option>
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="system-input-box">
                                <label><AdminText>Телефон</AdminText></label>
                                <input required placeholder={translateAdmin("Введите номер тел.")} value={newBooking.phone_number} type="telephone" name="phone_number" onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="system-column">
                            <div className="system-input-box">
                                <label><AdminText>Начало брони</AdminText></label>
                                <input required value={newBooking.available_from} placeholder={translateAdmin("Заезд")} type="date" name='available_from' onChange={handleInputChange} />
                            </div>
                            <div className="system-input-box">
                                <label><AdminText>Окончание брони</AdminText></label>
                                <input required value={newBooking.available_to} placeholder={translateAdmin("Выезд")} type="date" name='available_to' onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="system-input-box system-address">
                            <label><AdminText>Тип номера</AdminText></label>
                            <div className="system-column">
                                <div className="system-select-box">
                                    <select required value={newBooking.room_id || ''} onChange={handleInputChange} name='room_id'>
                                        <option value="0"><AdminText>Не выбрано</AdminText></option>
                                        {rooms && rooms.length > 0 ? (
                                            rooms.map((room) => (
                                                <option key={room.id} value={room.id}>{room.translations.room_type[language]}</option>
                                            ))
                                        ) : (
                                            <option value=""><AdminText>Нет номеров</AdminText></option>
                                        )}

                                    </select>
                                </div>
                                <input placeholder={selectedPrice || translateAdmin("Номер не выбран")} disabled type="text" />
                            </div>
                        </div>

                        <div className="system-column">
                            <div className="system-input-box">
                                <label><AdminText>Заметка</AdminText></label>
                                <input value={newBooking.note_text} placeholder={translateAdmin("Напишите заметку")} type="text" name='note_text' onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className='flex-btns'>
                            <button type='button' className="system-booking-table-btn system-booking-table-btn-cancel" onClick={onClose}><AdminText>Отмена</AdminText></button>
                            <button type='button' className="system-booking-table-btn system-booking-table-btn-edit" disabled={isDisabled} onClick={() => check()}><AdminText>Проверить</AdminText></button>
                            <button type='button' className="system-booking-table-btn system-booking-table-btn-view" disabled={isDisabled} onClick={() => sendData()}><AdminText>Поставить бронь</AdminText></button>
                        </div>
                        {messageNewData.length ? (
                            <span className='error-message'>{messageNewData}</span>
                        ) : (null)}
                    </form>
                </div>
            </section>
        </div>
    );
}

export default BookingNew;